import React, { useCallback, useRef } from 'react';
import BZModal from 'BZModal';
import cls from 'classnames';
import { CloseIcon, TicketHorizontalIcon, PersonLoginIcon } from '@bizzabo/icons';

import { notifyRedirectToTicketWidget } from './LoginPopover';
import { sendCustomClick } from 'utils/SnowplowUtils';
import { sendAnalytics } from 'utils/analyticsUtils';
import {
    buttonTypes,
    loginSubCategory,
    registerSubCategory
} from '../../../constants/SnowplowConst';
import { loginSpinnerOrigin } from '../../../constants/Enums';

const RegisterAndLoginModal = ({
    onHide,
    show,
    eventName,
    onLoginClick,
    eventUrls: { registrationsUrl },
    analyticData,
    setLoginV2SpinnerOrigin,
    loginV2LoadingState,
}) => {
    const isLoginV2Loading = loginV2LoadingState.isLoading
        && loginV2LoadingState.spinnerOrigin === loginSpinnerOrigin.REGISTER_AND_LOGIN_MODAL;

    const loginBtnClassName = cls('cta-button cta-button-large font-size-13 custom-color color-1-background  margin-top-medium color-1-hover-opacity', {
        'with-spinner': isLoginV2Loading
    });

    const loginButtonRef = useRef();
    const registerButtonRef = useRef();

    const handleLoginClick = useCallback(
        (e) => {
            sendAnalytics('loginClick', analyticData);
            sendCustomClick(buttonTypes.login, loginSubCategory.loginModalNewFlow, loginButtonRef);
            onLoginClick(e);
            setLoginV2SpinnerOrigin?.(loginSpinnerOrigin.REGISTER_AND_LOGIN_MODAL);
        },
        [analyticData],
    );

    const handleRegisterClick = useCallback(
        (...args) => {
            sendAnalytics('registerClick', analyticData);
            sendCustomClick(buttonTypes.register, registerSubCategory.registerModalNewFlow, registerButtonRef);
            notifyRedirectToTicketWidget(...args);
        },
        [analyticData]
    );

    return (
        <BZModal
            modalCls="agenda-modal register-login-modal"
            color='white'
            show={show}
            onHide={onHide}
            hideFooter
            disableBackdrop
        >
            <button className="close-btn custom-color color-1-background color-1-hover-opacity" onClick={onHide}>
                <CloseIcon fill="var(--page-contrast-to-main-color, #fff)" />
            </button>
            <div className="register-login-modal-content text-center">
                <h4 className="title font-size-20">Welcome to {eventName}</h4>
                <div className="subtitle font-size-14">You must be logged in and registered to personalize your agenda, save seats for sessions, access virtual sessions and more!</div>
                <div className="inner-container">
                    <div className="text-center">
                        <TicketHorizontalIcon color="#32333C" fontSize={40} className="display-block margin-auto" />
                        <strong>Not registered yet?</strong>
                        <div>Get registered to access the full content</div>
                        <a
                            ref={registerButtonRef}
                            href={registrationsUrl}
                            onClick={handleRegisterClick}
                            className="cta-button cta-button-large font-size-13 custom-color color-1 color-1-border margin-top-medium color-1-hover-opacity-outline"
                            target="_top"
                        >
                            Register
                        </a>
                    </div>
                    <div className="text-center login-container">
                        <PersonLoginIcon color="#32333C" fontSize={40} className="display-block margin-auto" />
                        <strong>Already registered for the event?</strong>
                        <div>Simply log in to get the full experience</div>
                        <button
                            ref={loginButtonRef}
                            onClick={handleLoginClick}
                            className={loginBtnClassName}
                            disabled={isLoginV2Loading}
                        >
                            {isLoginV2Loading ? <i className="fa fa-spinner fa-spin font-size-24"/> : 'Log in'}
                        </button>
                    </div>
                </div>
            </div>
        </BZModal>
    );
};

export default RegisterAndLoginModal;
